export default __webpack_public_path__ + "cbe4a25787c50d2c030e988dc0f619b0.png";